import { useContext, useState } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import { DatosInicioContext } from "../../context/DatosInicioContext";
import formatearValores from "../../helpers/formatearAPeso";
import formatearFecha from "../../helpers/formatearFecha";
import jsPDF from "jspdf";
import "jspdf-autotable";
import logo from "../../assets/img/Logo ZOCO.png";
import footerImg from "../../assets/img/QR orden pago.png";
import { getToken } from "../../utils/auth";


const ItemsTablaTicket = ({
    fecha,
    costoFinancieroEn,
    totalBruto,
    arancel,
    iva21,
    retencionIva,
    impuestoDebitoCredito,
    retencionProvincial,
    retencionGanacia,
    totalConDescuentos,
}) => {
    const { darkMode } = useContext(DarkModeContext);
    const { datos } = useContext(DatosInicioContext);
    const comercioSeleccionado = datos?.comercio;

    const valoresFormateados = formatearValores(
        totalBruto,
        costoFinancieroEn,
        arancel,
        iva21,
        impuestoDebitoCredito,
        iva21,
        impuestoDebitoCredito,
        retencionProvincial,
        retencionGanacia,
        retencionIva,
        totalConDescuentos
    );

    const fechaObj = new Date(fecha);
    const dia = String(fechaObj.getDate()).padStart(2, "0");
    const mes = String(fechaObj.getMonth() + 1).padStart(2, "0");
    const anio = fechaObj.getFullYear();
    const fechaLiqStr = isNaN(fechaObj) ? "-" : `${dia}-${mes}-${anio}`;

    const [descargando, setDescargando] = useState(false);
    const fechaFormateada = formatearFecha(fecha);

    const generarOrdenDePago = async (fecha) => {
        setDescargando(true);
        const token = getToken();

        try {
            const respuesta = await fetch(process.env.REACT_APP_API_PDF_ORDEN_PAGO, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    Token: token,
                    FechaPago: fecha,
                    Comercio: comercioSeleccionado,
                }),
            });

            if (!respuesta.ok) throw new Error("Error al obtener datos del backend");
            const data = await respuesta.json();
            const comercios = data.comercios || [];

            for (const comercio of comercios) {
                for (const tipo of comercio.tiposTarjeta) {
                    const doc = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const pageHeight = doc.internal.pageSize.getHeight();

                    const info = comercio.info;
                    const acumulados = tipo.acumulados;
                    const datos = tipo.datos;
                    const sumas = tipo.sumas;

                    const startX = 25;
                    const startY = 25;
                    const alto = 60;
                    const usableWidth = pageWidth - startX * 2;
                    const sectionWidth = usableWidth / 5;

                    // Encabezado principal
                    doc.setFillColor(255, 255, 255);
                    doc.roundedRect(startX, startY, usableWidth, alto, 10, 10, "F");
                    doc.setDrawColor(220);
                    doc.setLineWidth(0.2);
                    doc.setGState(new doc.GState({ opacity: 0.2 }));
                    doc.setFillColor(0, 0, 0);
                    doc.rect(startX + 3, startY + alto + 2, usableWidth - 6, 2, "F");
                    doc.setGState(new doc.GState({ opacity: 1 }));

                    for (let i = 1; i < 5; i++) {
                        const lineX = startX + i * sectionWidth;
                        doc.setDrawColor(230);
                        doc.line(lineX, startY + 8, lineX, startY + alto - 8);
                    }

                    const baseY = startY + 20;
                    doc.addImage(logo, "PNG", startX + 25, baseY, 60, 28);

                    const xOrden = startX + sectionWidth + sectionWidth / 2;
                    const yOrden = startY + alto / 2;
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(8);
                    doc.text("ORDEN DE PAGO", xOrden, yOrden, { align: "center", baseline: "middle" });

                    const xZoco = startX + sectionWidth * 2 + 10;
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(5.5);
                    doc.text("ZOCO - SERVICIOS DE PAGO", xZoco, baseY);
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(5);
                    doc.text("CUIT: 30 - 71.679.976 - 6", xZoco, baseY + 7);
                    doc.text("liquidaciones@zocoweb.com.ar", xZoco, baseY + 14);
                    doc.text("www.zocoweb.com.ar", xZoco, baseY + 21);

                    // Bloque comercial
                    const xCom = startX + sectionWidth * 3 + 10;
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(5.5);
                    doc.text("ESTABLECIMIENTO COMERCIAL", xCom, baseY);
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(5);

                    const direccionValida =
                        info.direccion && info.direccion.toUpperCase() !== "SIN DIRECCIÓN"
                            ? info.direccion
                            : "";

                    let line = baseY + 7;
                    doc.text(`EMPRESA: ${info.empresa}`, xCom, line);
                    line += 7;
                    doc.text(`DIRECCIÓN: ${direccionValida}`, xCom, line);
                    line += 7;
                    doc.text(`PROVINCIA: ${info.provincia}`, xCom, line);
                    line += 7;
                    doc.text(`TEL: ${info.telefono ?? "-"}`, xCom, line);
                    line += 7;
                    doc.text(`EMAIL: ${info.email ?? "-"}`, xCom, line);

                    // Fecha y banco
                    const xFecha = startX + sectionWidth * 4 + 10;
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(5.5);
                    doc.text("FECHA", xFecha, baseY);
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(5);

                    let yFecha = baseY + 8;
                    doc.text(`LIQUIDACIÓN: ${fechaLiqStr}`, xFecha, yFecha);
                    yFecha += 7;
                    doc.text(`BANCO: ${info.banco ?? "-"}`, xFecha, yFecha);
                    yFecha += 7;
                    doc.text(`N° CUENTA: ${info.nroCuenta ?? "-"}`, xFecha, yFecha);

                    // Sección montos
                    const startYMontos = startY + alto + 30;
                    doc.setFillColor(242, 244, 248);
                    doc.roundedRect(45, startYMontos - 8, pageWidth - 90, 22, 10, 10, "F");
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(9);
                    doc.text("MONTO ACUMULADO (MES CORRIENTE)", pageWidth / 2, startYMontos + 8, {
                        align: "center",
                    });

                    const labels = ["HOY SE ACREDITA", "ACUMULADO", "DÉBITO", "CUOTA"];
                    const values = [
                        acumulados.hoySeAcredita,
                        acumulados.acumulado,
                        acumulados.acumuladoDebito,
                        acumulados.acumuladoCredito,
                    ];

                    const boxW = (pageWidth - 150) / 4;
                    const baseX = 70;
                    const baseYMontos = startYMontos + 28;

                    labels.forEach((label, i) => {
                        const x = baseX + i * boxW;
                        doc.setDrawColor(210);
                        doc.setFillColor(255, 255, 255);
                        doc.roundedRect(x, baseYMontos, boxW - 30, 45, 14, 14, "F");
                        doc.setFont("helvetica", "bold");
                        doc.setFontSize(7);
                        doc.text(label, x + (boxW - 30) / 2, baseYMontos + 12, { align: "center" });
                        doc.setFontSize(9.5);
                        doc.text(`$ ${values[i] || "0,00"}`, x + (boxW - 30) / 2, baseYMontos + 30, {
                            align: "center",
                        });
                    });

                    // 📄 Tabla de operaciones
                    const startYTabla = baseYMontos + 70;
                    const columnas = [
                        "Terminal",
                        "N° Operación",
                        "Fecha OP",
                        "Tarjeta",
                        "Cuotas",
                        "Bruto",
                        "Costo Fin.",
                        "Anticipo",
                        "Arancel",
                        "IVA",
                        "Cost. transc.",
                        "Ret. IIBB",
                        "Ret. Ganancia",
                        "Ret. IVA",
                        "Total OP",
                    ];

                    const filasTabla = datos.map((d) => [
                        d.terminal,
                        d.nroOperacion,
                        d.fechaOperacion,
                        d.tarjeta,
                        d.cuotas,
                        `$${d.bruto}`,
                        `$${d.costoFinanciero}`,
                        `$${d.costoPorAnticipo}`,
                        `$${d.arancel}`,
                        `$${d.ivaArancel}`,
                        `$${d.impDebitoCredito}`,
                        `$${d.retencionIIBB}`,
                        `$${d.retencionGanancia}`,
                        `$${d.retencionIVA}`,
                        `$${d.totalOP}`,
                    ]);

                    const table = doc.autoTable({
                        startY: startYTabla,
                        head: [columnas],
                        body: filasTabla,
                        styles: { fontSize: 6, halign: "center", cellPadding: 1.5 },
                        headStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] },
                        alternateRowStyles: { fillColor: [245, 245, 245] },
                        theme: "striped",
                        margin: { left: 25, right: 25 },
                        tableWidth: pageWidth - 50,
                    });

                    // ⚙️ Nueva lógica: evitar que la tabla toque el footer
                    let finalY = doc.lastAutoTable.finalY;
                    if (finalY > pageHeight - 260) {
                        doc.addPage();
                        finalY = 80; // margen superior nuevo para el footer
                    }

                    // ----- FOOTER -----
                    const footerY = finalY + 20;
                    const halfWidth = (pageWidth - 100) / 2;

                    doc.setFillColor(255, 255, 255);
                    doc.roundedRect(30, footerY - 20, pageWidth - 60, 200, 20, 20, "F");

                    const leftX = 50;
                    doc.setFillColor(242, 244, 248);
                    doc.roundedRect(leftX, footerY - 5, halfWidth - 20, 20, 8, 8, "F");
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(9);
                    doc.text("RESUMEN FISCAL", leftX + (halfWidth - 20) / 2, footerY + 8, {
                        align: "center",
                    });

                    const resumenX = leftX + 10;
                    const resumenY = footerY + 25;
                    const resumenW = halfWidth * 0.55;

                    doc.setFillColor(255, 255, 255);
                    doc.roundedRect(resumenX, resumenY, resumenW, 140, 20, 20, "F");

                    doc.setFontSize(8);
                    doc.setFont("helvetica", "bold");
                    doc.text("RESUMEN OPERACIONES", resumenX + 15, resumenY + 15);
                    doc.setFontSize(7);
                    doc.setFont("helvetica", "normal");

                    const resumenData = [
                        ["BRUTO", sumas.bruto],
                        ["Arancel", sumas.arancel],
                        ["IVA 21%", sumas.ivaArancel],
                        ["Cost. transc.", sumas.impDebitoCredito],
                        ["Costo Financiero", sumas.costoFinanciero],
                        ["Costo Anticipo", sumas.costoPorAnticipo],
                        ["RET. IIBB", sumas.retencionIIBB],
                        ["RET. GANANCIAS", sumas.retencionGanancia],
                        ["RET. IVA", sumas.retencionIVA],
                    ];

                    let y = resumenY + 30;
                    resumenData.forEach(([label, value]) => {
                        doc.text(label, resumenX + 15, y);
                        doc.text(`$ ${value}`, resumenX + resumenW - 15, y, { align: "right" });
                        y += 13;
                    });

                    doc.setFont("helvetica", "bold");
                    doc.text("TOTAL OP", resumenX + 15, y + 2);
                    doc.text(`$ ${sumas.totalOP}`, resumenX + resumenW - 15, y + 2, {
                        align: "right",
                    });

                    const globosX = resumenX + resumenW + 15;
                    const globosY = resumenY + 5;
                    const globoW = halfWidth - resumenW - 35;
                    const globoH = 40;

                    const globos = [
                        ["RETENCIÓN DE GANANCIAS", sumas.retencionGanancia],
                        ["RETENCIÓN IVA", sumas.retencionIVA],
                        ["RETENCIÓN IIBB", sumas.retencionIIBB],
                    ];

                    globos.forEach((g, i) => {
                        const yPos = globosY + i * (globoH + 10);
                        doc.setFillColor(255, 255, 255);
                        doc.roundedRect(globosX, yPos, globoW, globoH, 18, 18, "F");
                        doc.setFont("helvetica", "bold");
                        doc.setFontSize(7);
                        doc.text(g[0], globosX + globoW / 2, yPos + 14, { align: "center" });
                        doc.setFontSize(11);
                        doc.text(`$ ${g[1] || "-"}`, globosX + globoW / 2, yPos + 32, {
                            align: "center",
                        });
                    });

                    const rightX = leftX + halfWidth + 10;
                    const rightW = halfWidth - 20;
                    doc.setFillColor(255, 255, 255);
                    doc.roundedRect(rightX, footerY - 5, rightW, 175, 20, 20, "F");
                    doc.addImage(footerImg, "PNG", rightX + 10, footerY + 5, rightW - 20, 155);

                    const nombreLimpio = comercio.comercio.replace(/[^a-z0-9]/gi, "_");
                    const tipoNombre =
                        tipo.tipoTarjeta === "QR"
                            ? "_QR"
                            : tipo.tipoTarjeta === "NARANJA S"
                                ? "_NARANJA"
                                : "_GENERAL";

                    const nombreArchivo = `OrdenPago_${nombreLimpio}${tipoNombre}_${fechaLiqStr}.pdf`;
                    doc.save(nombreArchivo);
                }
            }
        } catch (error) {
            console.error("Error al generar PDF:", error);
        }

        setDescargando(false);
    };

    return (
        <tr className={darkMode ? "tabla-borde-bottom text-white" : "tabla-borde-bottom text-dark"}>
            <td className="fs-12-a-10 lato-regular py-3 priority-1">{fechaFormateada}</td>
            <td className="fs-12-a-10 lato-regular py-3 priority-2">$ {valoresFormateados[0]}</td>
            <td className="fs-12-a-10 lato-regular py-3 priority-3">$ {valoresFormateados[1]}</td>
            <td className="fs-12-a-10 lato-regular py-3 priority-4">$ {valoresFormateados[2]}</td>
            <td className="fs-12-a-10 lato-regular py-3 priority-5">$ {valoresFormateados[3]}</td>
            <td className="fs-12-a-10 lato-regular py-3 priority-6">$ {valoresFormateados[4]}</td>
            <td className="fs-12-a-10 lato-regular py-3 priority-7">$ {valoresFormateados[7]}</td>
            <td className="fs-12-a-10 lato-regular py-3 priority-8">$ {valoresFormateados[8]}</td>
            <td className="fs-12-a-10 lato-regular py-3 priority-9">$ {valoresFormateados[9]}</td>
            <td className="fs-12-a-10 lato-regular py-3 priority-1">
                ${valoresFormateados[10]}
            </td>
            <td className="fs-12-a-10 lato-regular priority-1">
                <button
                    type="button"
                    className="btn-slide-descargar"
                    onClick={() => generarOrdenDePago(fechaFormateada)}
                    disabled={descargando}
                >
                    {descargando ? "Generando..." : "Descargar Orden"}
                </button>
            </td>
        </tr>
    );
};

export default ItemsTablaTicket;
